import React, { useState } from "react";
import { Icons } from "../../atoms/Icons";
import "./otherretirementsavingsdb.scss";
import { Card, Col, Row } from "react-bootstrap";
import Buttons from "../../atoms/Buttons";
import FormFields from "../../atoms/FormFields";
import { useNavigate } from "react-router-dom";
import { addCommas, isHybridMember } from "../../helpers/helpers";
const OtherRetirementSavingsDBModal = (props) => {
  const navigate = useNavigate();
  const [disableDoneBtn, setDisableDoneBtn] = useState(false);
  const [retirementTotValue, setRetirementTotValue] = useState(
    props.expectedSavingsIncome, //eslint-disable-line
  );
  const [estIncome, setEstIncome] = useState(props.dBEstIncome);
  const [dBAge, setDBAge] = useState(props.otherIncomeDBAge);
  const btnDoneHandler = () => {
    if (props.otherRetirementModal) {
      props.setExpectedSavingsIncome(retirementTotValue);
      props.setOtherRetirementModal(false);
    } else {
      props.setDBEstIncome(estIncome);
      props.setOtherIncomeDBAge(dBAge);
      props.setOtherIncomeDBModal(false);
    }
  };
  const changeRetirementTotValue = (event) => {
    const value = formatValue(event);
    setRetirementTotValue(value);
  };
  const changeEstIncome = (event) => {
    const value = formatValue(event);
    setEstIncome(value);
  };
  const changeDBAge = (event) => {
    const value = event.target.value;
    //Allow empty string for controlled input
    if (value === "") {
      setDBAge(value);
      return;
    }
    //Convert to number and validate input
    const numericValue = parseInt(value, 10);
    //First digit logic: allow 5,6,7 or 8
    if (value.length === 1) {
      if (value >= "5" && value <= "8") {
        setDBAge(value);
        setDisableDoneBtn(true);
      }
      return;
    }
    //If two digits or more, check if the entire number fails within 55-80
    if (numericValue >= 55 && numericValue <= 80) {
      setDBAge(value);
      setDisableDoneBtn(false);
    }
  };
  const formatValue = (event) => {
    let value =
      event.target.value === "£"
        ? "0"
        : event.target.value === ""
          ? "0"
          : event.target.value.split("£")[1];
    const formattedValue = (
      Number(value.replace(/\D/g, "")) || "0"
    ).toLocaleString();
    return formattedValue;
  };
  const handleOnKeyDown = (event) => {
    const { key } = event;
    if (
      (!/[0-9]/.test(event.key) && key === "Backspace" && key === "Delete") ||
      key === "ArrowLeft" ||
      key === "ArrowRight" ||
      key === "Tab"
    ) {
      event.preventDefault();
    }
  };
  return (
    <div className="other-retirement-modal-container">
      <div className="pensionable-edit-close">
        <Icons
          iconname="close-large"
          variant="icon-sixteen-px"
          clickHandler={props.handleCloseButton}
        />
      </div>
      <p className="title text-center">{props.modalTitle}</p>
      <p className="text-center description">{props.description}</p>
      <Card className="mt-5">
        <Row>
          <Col xs={12} sm={6} md={6}>
            <Row>
              <Col xs={2} className="add-icon">
                <Icons iconname="add" variant="icon-twenty-four-px" />
              </Col>
              <Col xs={10}>
                <p className="sub-heading">{props.subHeading}</p>
                <p className="sub-description">{props.subDescription}</p>
                {props.otherRetirementModal ? (
                  <Buttons
                    largeButton={true}
                    className="tertiary"
                    name="Find your old pensions"
                    iconname="chevron-large-right"
                    variantname="icon-sixteen-px"
                    handleClick={() => navigate("/manage?tab=otherPots")}
                  />
                ) : props.section === "Plan your future" ? (
                  ""
                ) : isHybridMember(props?.membershipType) ? (
                  <Buttons
                    largeButton={true}
                    className="tertiary"
                    name="Find your DB pension projection with TPT"
                    iconname="chevron-large-right"
                    variantname="icon-sixteen-px"
                    handleClick={() =>
                      window.open(
                        "https://memberonline.tpt.org.uk/Member",
                        "_blank", //eslint-disable-line
                      )
                    }
                  />
                ) : null}
              </Col>
            </Row>
          </Col>
          <Col xs={12} sm={6} md={6}>
            {props.otherRetirementModal ? (
              <Row className="mt-4">
                <Col className="text-end">
                  <FormFields
                    Label="Total value"
                    disabled={false}
                    value={`£${addCommas(retirementTotValue)}`}
                    variant="form-field-default"
                    changeHandler={changeRetirementTotValue}
                    maxLength={40}
                  />
                </Col>
              </Row>
            ) : (
              <>
                <Row className="mt-4">
                  <Col className="text-end">
                    <FormFields
                      Label="Estimated income"
                      disabled={false}
                      value={`£${addCommas(estIncome)}`}
                      variant="form-field-default"
                      changeHandler={changeEstIncome}
                      maxLength={40}
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col className="text-end">
                    <FormFields
                      Label="What age this will be payable from?"
                      disabled={false}
                      type="text"
                      value={dBAge}
                      variant="form-field-default"
                      changeHandler={changeDBAge}
                      onKeyDown={handleOnKeyDown}
                      data-testid="dBAge-input"
                    />
                  </Col>
                </Row>
              </>
            )}
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={6} className="text-start">
            <Buttons
              name="Back"
              className="secondary"
              handleClick={props.btnBackHandler}
            />
          </Col>
          <Col xs={6} className="text-end">
            <Buttons
              name="Done"
              className="primary"
              disabled={disableDoneBtn}
              handleClick={btnDoneHandler}
            />
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default OtherRetirementSavingsDBModal;
